import { useMemo } from 'react';

import type { OrgsSchools, OrgItem } from 'app/dataProviders/org/OrgsDataProvider';

type Options = {
  orgId?: number,
}

export default function useDateFrom(orgs: OrgsSchools, options: Options): OrgItem['from'] | undefined {
  const { orgId } = options;

  const from = useMemo(() => {
    if (orgId == null) {
      return undefined;
    }

    const orgKey = String(orgId);
    const org = orgs[orgKey];

    return org?.from ?? undefined;
  }, [orgs, orgId]);

  return from;
}
